export default __webpack_public_path__ + "static/dorahacks-8e0d64012a84c3b3d2e17367908e4c62.svg";